"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClusterWizardContext = exports.ClusterWizardContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.ClusterWizardContext = react_1.default.createContext(null);
const useClusterWizardContext = () => {
    const context = react_1.default.useContext(exports.ClusterWizardContext);
    if (!context) {
        throw new Error('useClusterWizardContext must be used within ClusterWizardContextProvider');
    }
    return context;
};
exports.useClusterWizardContext = useClusterWizardContext;
//# sourceMappingURL=ClusterWizardContext.js.map